import { React, PropTypes, reduxConnect, styled, css } from '../lib/imports';
import { Spacing, ToggleSwitch, Text } from '../components';
import { sendNotificationStatus } from '../onboarding/actions';

const containerBaseStyles = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${theme.spacings.zetta};
`;

const Container = styled('div')(containerBaseStyles);

const reminderSwitchBaseStyles = ({ theme }) => css`
  margin-right: ${theme.spacings.kilo};
`;

const ReminderSwitch = styled('div')(reminderSwitchBaseStyles);

const Reminders = ({ isActive, text, handleReminderStatus, reminderHasUpdated }) => {
  return (
    <Spacing sizeTop='giga' sizeBottom='giga'>
      <Container>
        <ReminderSwitch
          onClick={() => {
            return handleReminderStatus(!isActive, !reminderHasUpdated);
          }}
        >
          <ToggleSwitch isActive={isActive} />
        </ReminderSwitch>
        <Text size='mega' noMargin>
          {text}
        </Text>
      </Container>
    </Spacing>
  );
};

Reminders.propTypes = {
  handleReminderStatus: PropTypes.func,
  isActive: PropTypes.bool,
  text: PropTypes.string,
  reminderHasUpdated: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const { strings, reminders } = state;
  const { isActive, reminderHasUpdated } = reminders;

  const allStrings = {
    text: strings['notifications/reminders/text'],
  };

  return {
    ...allStrings,
    isActive,
    reminderHasUpdated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleReminderStatus: (status) => dispatch(sendNotificationStatus(status)),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Reminders);
